<template>
  <div class="home-screen">
    <div class="container">
      <div class="row align-items-center mt-5">
        <div class="col-md-6">
          <h1>Damien Collectible Toy</h1>
          <p>
            The time is finally here to collect the first release of DeadHeads
            physical toys! Everyone's favorite character Damien has been brought
            to RL as a 50cm tall toy to sit atop your mantle. Purchase this
            soulbound token and fill out the shipping information to recieve
            yours (allow 1-3 months).
          </p>
          <mint @minted="loadShipment" />
        </div>
        <div class="col-md-6 text-center">
          <img class="w-100" src="/static/img/doll.gif" alt="" />
        </div>
      </div>

      <div class="divider my-5"></div>
      <div v-if="hasRemainingRequests">
        <div>
          You still have {{ remainingRequests }} toys without a home. Please
          fill in your address.
        </div>
        <button
          class="claim-button mb-3"
          @click="openShipmentDetailsModal"
          :disabled="loading"
        >
          Claim
        </button>
      </div>
      <div class="row mb-3">
        <div class="col-12 col-md-3">
          <img class="w-100 m-1" src="/static/img/01.jpg" alt="Gallery" />
        </div>
        <div class="col-12 col-md-3">
          <img class="w-100 m-1" src="/static/img/02.jpg" alt="Gallery" />
        </div>
        <div class="col-12 col-md-3">
          <img class="w-100 m-1" src="/static/img/03.jpg" alt="Gallery" />
        </div>
        <div class="col-12 col-md-3">
          <img class="w-100 m-1" src="/static/img/04.jpg" alt="Gallery" />
        </div>
      </div>

      <h1 class="text-center">
        SOCIALS
      </h1>

      <div
        class="d-flex flex-column align-items-center flex-md-row justify-content-md-between mb-5"
      >
        <a href="https://www.youtube.com/watch?v=yVygJiV61vM" target="_blank">
          YouTube
        </a>
        <a href="https://discord.gg/deadheads" target="_blank">
          Discord
        </a>
        <a href="https://twitter.com/DeadHeadsNFT" target="_blank">
          Twitter
        </a>
        <a href="https://instagram.com/deadheads_nft" target="_blank">
          Instagram
        </a>
      </div>
    </div>

    <v-shipment-details-modal
      :active="modals.shipmentDetails.active"
      :totalPending="remainingRequests"
      :signature="signature"
      @submited="loadData"
      @close="closeShipmentDetailsModal"
    ></v-shipment-details-modal>

    <v-loading-modal :active="modals.loading.active"></v-loading-modal>
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import VShipmentDetailsModal from "../components/ShipmentDetailsModal.vue";
import VLoadingModal from "../components/LoadingModal.vue";
import dollsContractService from "../services/dollsContractService";
import { getRequests } from "../services/wearablesApiService";
import Mint from "../components/Mint.vue";

export default {
  name: "Home",
  components: {
    VShipmentDetailsModal,
    VLoadingModal,
    Mint,
  },
  data() {
    return {
      modals: {
        shipmentDetails: {
          active: false,
          totalPending: 0,
        },
        loading: {
          active: false,
        },
      },
      totalTokens: 0,
      signature: null,
      requests: 0,
      balanceOf: 0,
      loading: true,
    };
  },
  computed: {
    ...mapState(["accountAddress", "networkId"]),
    ...mapGetters(["isConnected"]),
    remainingRequests() {
      return this.balanceOf - this.requests;
    },
    hasRemainingRequests() {
      return this.remainingRequests > 0;
    },
  },
  watch: {
    async accountAddress(address) {
      if (address && this.networkId == process.env.VUE_APP_NETWORK_ID) {
        this.loadData();
      }

      this.modals.shipmentDetails.active = false;
      this.signature = null;
    },
    networkId(id) {
      this.modals.shipmentDetails.active = false;
    },
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.loading = true;
      Promise.all([
        dollsContractService.balanceOf(this.accountAddress),
        getRequests(this.accountAddress),
      ]).then(([balanceOf, requests]) => {
        this.balanceOf = +balanceOf;
        this.requests = requests.data;
        this.loading = false;
      });
    },
    loadShipment() {
      this.loadData();
      this.openShipmentDetailsModal();
    },
    openShipmentDetailsModal() {
      this.modals.shipmentDetails.active = true;
    },
    openLoadingModal() {
      this.modals.loading.active = true;
    },
    closeShipmentDetailsModal() {
      this.loadData();
      this.modals.shipmentDetails.active = false;
    },
    closeLoadingModal() {
      this.modals.loading.active = false;
    },
  },
};
</script>
<style lang="css" scoped>
video {
  max-width: 300px;
}
</style>
